/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowDownLeft(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M197.65674,69.65723,127.314,140l46.34327,46.34277A8.00038,8.00038,0,0,1,168,200H64a8.00039,8.00039,0,0,1-8-8V88a8.00065,8.00065,0,0,1,13.65723-5.65723L116,128.686l70.34326-70.34327a8.00018,8.00018,0,1,1,11.31348,11.31446Z" />
    </Svg>
  );
}

export default ArrowDownLeft;
